const logSubscriptionCancelled = (planName: string) => {
  window.dataLayer?.push({
    event: 'cancel_subscription',
    'clear-eventCategory': 'profile',
    'clear-eventAction': 'cancel_subscription',
    'clear-eventLabel': planName,
  });
};

export { logSubscriptionCancelled };
